import { Deserializable } from '../../../models/protocols/deserializable';
import { Address } from '../../../models/users/dto/address';

export class BeneficiaryTrustee implements Deserializable {
  id?: number | null;
  firstName!: string;
  middleName!: string | null;
  lastName!: string;
  socialInsuranceNumber!: string | null;
  email!: string;
  phoneNumberCountryCode!: string | null;
  phoneNumber!: string | null;
  birthDate!: string;
  address!: Address | null;

  onDeserialize() {
    const Deserialize = window.injector.Deserialize;
    if (this.address) {
      this.address = Deserialize.instanceOf(Address, this.address);
    }
  }
}
